// this is an autogenerated file from DesignSystem/LeadPreview/mutation-set-location.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_LeadPreview($lead_id: uuid!, $location_id: uuid!) {
  update_leads_leads_by_pk(
    pk_columns: { id: $lead_id }
    _set: { location_id: $location_id }
  ) {
    id
  }
}

`